<!-- 我的推广  -->
<template>
  <div class="cgh-view">
    <headView title="我的推广" :type="3" rightIcon="question-o" @onRight="onRight" ></headView>
    <div class="cgh-content">
      <div class="price-con">
        <div>
          <div>冻结佣金</div>
          <div>¥ {{userInfo.frozen_commission | numberTwo}}</div>
        </div>
        <div class="use-con">
          <div>可用佣金</div>
          <div class="price-use">¥ {{userInfo.commission_available | numberTwo}}</div>
        </div>
        <div>
          <div>累计佣金</div>
          <div>¥ {{userInfo.accumulated_commission | numberTwo}}</div>
        </div>
      </div>
      <div class="cgh-out" @click="toPath(0)">申请提现</div>
      <div class="cgh-tab">
        <div class="tab-item">
          <img src="@/assets/images/extentIcon/extentIcon2.png" />
          <div>
            <div class="title">推广用户</div>
            <div class="desc">邀请好友可获得更多佣金哦!</div>
          </div>
          <div class="cgh-btn" id="btn1" @click="toPath(1, '推广用户')">用户记录</div>
        </div>
        <div class="tab-item">
          <img src="@/assets/images/extentIcon/extentIcon3.png" />
          <div>
            <div class="title">佣金明细</div>
            <div class="desc">点击查看更多佣金获得记录!</div>
          </div>
          <div class="cgh-btn" id="btn2" @click="toPath(2, '佣金明细')">查看明细</div>
        </div>
        <div class="tab-item">
          <img src="@/assets/images/extentIcon/extentIcon1.png" />
          <div>
            <div class="title">提现记录</div>
            <div class="desc">查看更多记录!</div>
          </div>
          <div class="cgh-btn" id="btn3" @click="toPath(3, '提现记录')">查看记录</div>
        </div>
      </div>
    </div>
    <div class="cgh-company">
      <Divider>广州市全润通电子科技有限公司提供技术支持</Divider>
    </div>
  </div>
</template>

<script>
import headView from "@/components/headView/headView";
import { Divider, Toast } from "vant";
export default {
  data() {
    return {
      userInfo: {}
    };
  },
  created() {
    this._getInfo();
  },
  methods: {
    _getInfo () {
      // 获取信息
      let tost = Toast.loading({
        message: "加载中...",
        forbidClick: true,
      });
      this.$API.get('member/member_get', {}, 1).then(res => {
        if (res.status == 1) {
          this.userInfo = res.data;
        }
        tost.clear();
      });
    },
    onRight () {
      this.$router.push('/pointsDesc');
    },
    toPath(type, title) {
      if (type == 0) {
        this.$router.push("/priceOut");
      } else {
        this.$router.push({
          path: "/extensionTab",
          query: { type: type, title: title }
        });
      }
    }
  },
  components: {
    headView,
    Divider
  }
};
</script>
<style lang='scss' scoped>
@import "@/assets/style/minxi.scss";
.cgh-view {
  width: 100%;
  overflow: hidden;
  .cgh-content {
    margin-top: 40px;
    .price-con {
      width: 100%;
      height: 130px;
      display: flex;
      font-size: 14px;
      justify-content: space-around;
      flex-wrap: wrap;
      line-height: 30px;
      position: relative;
      z-index: -1;
      overflow: hidden;
      color: white;
      padding-top: 30px;
      .price-use {
        font-size: 16px;
        color: red;
      }
    }

    .price-con::after {
      content: "";
      width: 140%;
      height: 130px;
      position: absolute;
      left: -20%;
      top: 0;
      z-index: -1;
      border-radius: 0 0 60% 60%;
      background: linear-gradient(#fea138, #fe9036);
    }
    .cgh-out {
      padding: 12px 40px;
      background: #ed5229;
      font-size: 14px;
      color: white;
      position: absolute;
      top: 150px;
      left: 32%;
      z-index: 10;
      border-radius: 20px;
    }
    .cgh-tab {
      color: black;
      line-height: 20px;
      margin-top: 20px;
      .tab-item {
        width: 86%;
        margin: 0 0 30px 4%;
        border: 1px solid $borderColor;
        display: flex;
        align-items: center;
        border-radius: 20px;
        padding: 20px 10px;
        img {
          width: 40px;
          height: 40px;
          margin-right: 10px;
        }
        .title {
          font-size: 16px;
          font-weight: bold;
        }
        .desc {
          font-size: 10px;
          color: $bloeFontColor;
        }
        .cgh-btn {
          font-size: 12px;
          padding: 2px 10px;
          color: #f06161;
          border: 1px solid #f06161;
          border-radius: 10px;
          margin-left: auto;
        }
        #btn2 {
          color: orange;
          border: 1px solid orange;
        }
        #btn3 {
          color: #5f7cff;
          border: 1px solid #5f7cff;
        }
      }
    }
  }
  .cgh-company {
    width: 80%;
    position: absolute;
    bottom: 10px;
    left: 10%;
    .van-divider {
      font-size: 10px;
    }
  }
}
</style>